export const dashboard = {
  // Welcome Section
  welcomeBack: 'Willkommen zurück!',
  dayProgress: 'Tag {{current}} von {{total}} • Du machst großartige Fortschritte!',
  streak: 'Streak',
  days: 'Tage',

  // Date Navigation
  today: 'Heute',

  // Day Names (short)
  dayNames: {
    mon: 'Mo',
    tue: 'Di',
    wed: 'Mi',
    thu: 'Do',
    fri: 'Fr',
    sat: 'Sa',
    sun: 'So',
  },

  emptystate: {
    title: 'Kein aktiver Plan',
    subtitle: "Du hast noch keinen aktiven Ernährungsplan.",
    cta: "Meinen Plan erstellen"
  },

  generating: {
    title: 'Dein Plan wird erstellt...',
    subtitle: 'Dies dauert etwa 2-3 Minuten'
  },

  // noMealsForDay: 'Keine Mahlzeiten für diesen Tag',

  // Daily Summary Stats
  calories: 'Kalorien',
  protein: 'Protein',
  carbs: 'Kohlenhydrate',
  fat: 'Fett',
  grams: "Gramm",

  // Meals Progress
  yourMeals: 'Deine Mahlzeiten',
  noMealsForDay: "Für diesen Tag wurden keine Mahlzeiten gefunden",
  mealsCompleted: '{{completed}} von {{total}} erledigt • {{percentage}}% abgeschlossen',
  breakfast: 'Frühstück',
  lunch: 'Mittagessen',
  dinner: 'Abendessen',
  snack: 'Imbiss',
  snack1: 'Snack 1',
  snack2: 'Snack 2',
  completed: 'Erledigt',
  markComplete: 'Markieren',
  viewRecipe: 'Rezept anzeigen',
  generateRecipe: 'Rezept generieren',

  // Meal Times
  mealTimes: {
    breakfast: '07:00 - 09:00',
    lunch: '12:00 - 14:00',
    dinner: '18:00 - 20:00',
  },

  // Hydration Tracker
  waterIntake: 'Wasseraufnahme',
  stayHydrated: 'Bleib hydriert!',
  drankToday: 'Heute getrunken',
  cups: 'Tassen',
  goal: 'Ziel',

  // Daily Tip
  tipOfTheDay: 'Tipp des Tages',
  dailyTipText: 'Trinke ein Glas Wasser vor jeder Mahlzeit. Das hilft deinem Stoffwechsel und unterstützt dein Sättigungsgefühl!',

  // Quick Actions
  fullPlan: 'Vollständiger Plan',
  viewAll30Days: 'Alle 30 Tage ansehen',
  progress: 'Fortschritt',
  trackYourProgress: 'Deine Entwicklung verfolgen',

  upgradeToVip: 'Upgrade auf VIP, um alle Funktionen freizuschalten.',
  vipFeaturesDescription: 'Erhalte mit dem VIP-Plan vollen Zugriff auf personalisierte Ernährungspläne, detaillierte Analysen und priorisierten Support.',

  // Floating Action Button Menu
  fabMenu: {
    dashboardOverview: 'Dashboard-Übersicht',
    adjustPlan: 'Plan anpassen',
    viewAllRecipes: 'Alle Rezepte anzeigen',
    weightMeasurements: 'Schnelle Gewichtserfassung',
    viewAchievements: 'Erfolge ansehen',
    viewShoppingList: 'Einkaufsliste anzeigen',
    motivation: 'Motivation',
    todayAgenda: 'Was steht heute auf dem Plan?',
  },

  // Streak Modal
  streakModal: {
    title: 'Tage Streak!',
    subtitle: 'Du bist auf Feuer! 🔥',
    currentStreak: 'Aktueller Streak',
    longestStreak: 'Längster Streak',
    daysInRow: 'Tage in Folge',
    daysRecord: 'Tage Rekord',
    last7Days: 'Letzte 7 Tage',
    milestones: 'Meilensteine',
    milestone1Week: '1 Woche',
    milestone2Weeks: '2 Wochen',
    milestone1Month: '1 Monat',
    milestone2Months: '2 Monate',
    milestone100Days: '100 Tage',
    daysStreak: 'Tage Streak',
    achieved: 'Erreicht!',
    keepGoing: 'Weiter so!',
    daysToNext: 'Du bist nur noch {{days}} Tage von deinem nächsten Meilenstein entfernt. Bleib dran und erreiche die {{milestone}}-Marke!',
  },

  // Water Intake Modal
  waterModal: {
    title: 'Wasseraufnahme',
    subtitle: 'Tracke deine tägliche Hydration',
    reset: 'Zurücksetzen',
    cups: 'Tassen',
    of: 'von',
    quickActions: 'Schnellaktionen',
    cupsToday: 'Tassen heute',
    settings: 'Einstellungen',
    cupSize: 'Tassengröße',
    cupSizeSmall: '150ml (Klein)',
    cupSizeStandard: '200ml (Standard)',
    cupSizeMedium: '250ml (Mittel)',
    cupSizeLarge: '300ml (Groß)',
    cupSizeXLarge: '350ml (Extra Groß)',
    cupSizeBottle: '500ml (Flasche)',
    dailyTarget: 'Tagesziel (Tassen)',
    equivalentLiters: 'Entspricht {{liters}}L pro Tag',
    healthTips: 'Hydrations-Tipps',
    tip1: '💧 Trinke ein Glas Wasser direkt nach dem Aufwachen',
    tip2: '🍽️ Trinke vor jeder Mahlzeit ein Glas Wasser',
    tip3: '⏰ Stelle dir stündliche Erinnerungen ein',
    tip4: '🏃 Trinke extra Wasser nach dem Sport',
    tip5: '🌡️ An heißen Tagen mehr trinken',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },

  // ChatBot
  chatBot: {
    // Existing keys
    title: 'NutriBot Coach',
    subtitle: 'Vollzugriff auf Dashboard, Plan, Rezepte & mehr',
    placeholder: 'Frag mich über Ernährung, Rezepte oder deine Ziele...',
    footerNote: '💡 NutriBot hat vollen Zugriff auf Dashboard, Ernährungsplan, Rezepte, Einkaufsliste, Fortschritt & Einstellungen',
    quickAction1: 'Wochenliste erstellen',
    quickAction2: 'Rezept tauschen',
    quickAction3: 'Kalorien erhöhen',
    quickAction4: 'Profil bearbeiten',
    openNow: 'Jetzt öffnen',
    showInDashboard: 'Im Dashboard anzeigen',
    availableProducts: '🛒 Verfügbare Produkte für diese Woche:',
    seeProductCards: '(Siehe Produktkarten unten)',
    toShoppingList: 'Zur vollständigen Einkaufsliste',
    inStock: 'Auf Lager',
    buy: 'Kaufen',
    yesNo: '🤔 **Bitte antworte mit "Ja" oder "Nein"**\n\n• **Ja** = Ernährungsplan, Rezepte und Einkaufsliste werden automatisch angepasst\n• **Nein** = Nur Profil wird aktualisiert, alles andere bleibt unverändert',
    noMatch: 'Keine Übereinstimmung',
    online: 'Online',
    greeting: 'Hallo! 👋',
    introduction: 'Ich bin NutriBot, dein KI-Ernährungscoach. Bereit, deinen personalisierten Essensplan zu erstellen?',

    loadingMore: 'Ältere Nachrichten werden geladen...',

    // NEW: Chat interface translations
    searchPlaceholder: 'Nachrichten durchsuchen...',
    of: 'von',
    typing: 'Schreibt...',
    today: 'Heute',
    yesterday: 'Gestern',
    upgradePrompt: 'Upgrade auf VIP für unbegrenztes Coaching.',

    // NEW: Meal Plan Preview translations
    planPreview: {
      title: '{{days}}-Tage Essensplan Vorschau',
      expandAll: 'Alle erweitern',
      collapseAll: 'Alle einklappen',
      kcalPerDay: 'kcal/Tag',
      days: 'Tage',
      mealsPerDay: 'Mahlzeiten/Tag',
      day: 'Tag {{number}}',
      kcal: 'kcal',
      meals: 'Mahlzeiten',
      footerPrompt1: 'Sag',
      looksPerfect: 'sieht perfekt aus',
      footerPrompt2: 'um diesen Plan zu erstellen, oder',
      changeDay: 'ändere Tag X',
      footerPrompt3: 'um Anpassungen vorzunehmen!',
    },

    error: "Fehler",
    unknownError: "Entschuldigung, ein unbekannter Fehler ist aufgetreten",
    upgradeVip: "Upgrade auf VIP für unbegrenztes Coaching."
  },

  // Common
  close: 'Schließen',
  open: 'Öffnen',
  loading: 'Lädt...',
  error: 'Fehler',
  success: 'Erfolg',

  layout: {
    logo: 'NutriBot',
    // chatButton: 'Chat mit NutriBot',
    chatButton: 'NutriBot fragen',
    menu: {
      dashboard: 'Dashboard',
      nutritionPlan: 'Ernährungsplan',
      recipes: 'Rezepte',
      shoppingList: 'Einkaufsliste',
      progress: 'Fortschritt',
      profile: 'Profil',
      vipOnly: 'Diese Funktion ist nur für VIP-Mitglieder verfügbar!'
    },
    userMenu: {
      language: 'Sprache',
      learnMore: 'Mehr erfahren',
      help: 'Hilfe',
      upgradePlan: 'Plan upgraden',
      logout: 'Abmelden'
    }
  },

  completion: {
    title: 'Tag {{day}} Abgeschlossen',
    subtitle: 'Großartige Arbeit! 🎉',
    meals: 'Mahlzeiten',
    calories: 'kcal',
    streak: 'Du hast eine {{count}}-Tage-Serie!',
    continue: 'Weiter so!',
  },

  // Day Status Banner
  dayStatus: {
    completedToday: 'Tag Abgeschlossen! Großartige Arbeit!',
    completedPast: 'Tag {{day}} Abgeschlossen',
    stats: '{{calories}} kcal • {{protein}}g Protein • {{meals}}/{{total}} Mahlzeiten',

    missed: {
      title: 'Tag {{day}}',
      message1: '💪 Jeder Tag ist ein neuer Anfang!',
      message2: '🌟 Fortschritt, nicht Perfektion!',
      message3: '🎯 Fokus auf heute, du schaffst das!',
      message4: '💚 Schritt für Schritt, bleib dran!',
    },
  },

  logoutModal: {
    title: 'Abmeldung bestätigen',
    subtitle: 'Sie sind dabei, sich abzumelden',
    message: 'Sind Sie sicher, dass Sie sich abmelden möchten? Sie müssen sich erneut anmelden, um auf Ihr Dashboard zuzugreifen.',
    cancelButton: 'Abbrechen',
    confirmButton: 'Abmelden',
    loggingOut: 'Abmelden...',
  },

  // German translations for goalForecast

  goalForecast: {
    // Main titles
    title: 'Zielprognose',
    maintainTitle: 'Gewichtserhaltung',

    // No data states
    noData: 'Absolviere einige Tage deines Plans und erfasse dein Gewicht, um deine Zielprognose zu sehen.',

    // Weight labels
    current: 'Aktuell',
    currentWeight: 'Aktuelles Gewicht',
    target: 'Ziel',
    targetWeight: 'Zielgewicht',
    complete: 'Abgeschlossen',

    // Goal-specific labels
    lossRate: 'Abnahmerate',
    gainRate: 'Zunahmerate',
    toGo: 'noch zu verlieren',
    toGain: 'noch zuzunehmen',

    // Projected date section
    projectedDate: 'Voraussichtliches Zieldatum',
    days: 'Tage',
    weeks: 'Wochen',

    // Stats labels
    currentPace: 'Aktuelles Tempo',
    confidence: 'Zuverlässigkeit',
    calculating: 'Berechne...',

    // Status badges
    ahead: 'Vor dem Zeitplan',
    onTrack: 'Im Plan',
    behind: 'Leicht hinterher',
    stalled: 'Fortschritt stockt',
    insufficientData: 'Sammle Daten',

    // Maintain goal statuses
    maintainingWell: 'Gewicht gut gehalten',
    adjustNeeded: 'Kleine Anpassung nötig',

    // Contextual messages
    stalledMessage: 'Dein Fortschritt stockt. Erwäge eine Anpassung deiner Kalorienzufuhr oder deines Aktivitätsniveaus.',
    behindMessage: 'Du bist etwas hinter dem Zeitplan. Bleib dran und du kommst wieder auf Kurs!',

    // Info modal
    howItWorks: 'So funktioniert die Zielprognose',
    infoTheoryTitle: 'Dein Ernährungsplan (Theorie)',
    infoTheoryDesc: 'Erwartete Gewichtsveränderung durch dein aktuelles Kalorien',
    infoTheoryDescDeficit: 'defizit',
    infoTheoryDescSurplus: 'überschuss',
    infoRealityTitle: 'Dein tatsächlicher Fortschritt (Realität)',
    infoRealityDesc: 'Dein echter Gewichtstrend der letzten Wochen.',
    infoBlendingTitle: 'Intelligente Mischung',
    infoBlendingEarly: 'Anfangs: Mehr Theorie',
    infoBlendingLater: 'Später: Mehr Realität',
    infoStabilityTitle: 'Stabilitätsschutz',
    infoStabilityDesc: 'Dein Datum springt nicht aufgrund täglicher Schwankungen. Nur konstante Trends verschieben die Prognose.',
    infoImportantTitle: 'Wichtig',
    infoImportantDesc: 'Dies ist eine Prognose, keine Garantie. Setze deinen Plan fort, um auf Kurs zu bleiben!',
  }
};
